import { useMemo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    fetchDatasets,
    gridDatasetSelector,
    createFetchGridDataset
} from '@libs/datasets';
import { makeSideEffectCallback } from '@libs/makeContext';

import { WEEKLY_ALL_ATTENDANCE } from 'timeAndAttendance/redux.datasets';
import { DOMAIN_NAME } from 'timeAndAttendance/common';
import { WeeklyTimesheetsProvider } from './useWeeklyTimesheets';
import Filters from './Filters';
import DataTable from './DataTable';
import Pagination from './Pagination';

const TimesheetsWeeklyView = () => {
    const { data, currentPage, totalPages } = useSelector((state) =>
        gridDatasetSelector(state, DOMAIN_NAME, WEEKLY_ALL_ATTENDANCE)
    );
    const dispatch = useDispatch();
    const fetchWeeklyAllAttendance = useCallback(
        () => dispatch(fetchDatasets(WEEKLY_ALL_ATTENDANCE)),
        [dispatch]
    );
    const fetchGridWeeklyAllDataset = useCallback(
        (payload) =>
            dispatch(
                createFetchGridDataset(
                    DOMAIN_NAME,
                    WEEKLY_ALL_ATTENDANCE
                )(payload)
            ),
        []
    );

    const initialize = useCallback(
        (state) => ({
            ...state,
            data,
            totalPages,
            currentPage
        }),
        [currentPage, totalPages, data]
    );

    const middlewareProps = useMemo(
        () => ({
            fetchData: makeSideEffectCallback(fetchGridWeeklyAllDataset)
        }),
        []
    );

    useEffect(() => {
        fetchWeeklyAllAttendance();
    }, []);

    return (
        <WeeklyTimesheetsProvider
            initialize={initialize}
            middlewareProps={middlewareProps}
        >
            <Filters />
            <DataTable />
            <Pagination />
        </WeeklyTimesheetsProvider>
    );
};

export default TimesheetsWeeklyView;
